export default __webpack_public_path__ + "static/media/pinnedIcon.69a486d4.svg";